import React from "react";
import Button from "@mui/material/Button";
import SnackBar from "./Snackbar";

export default function () {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Button onClick={handleClick}>Open simple snackbar</Button>
      <SnackBar
        open={open}
        handleClose={handleClose}
        message="Label"
        button={2}
      />
    </>
  );
}
